module.exports = __webpack_public_path__ + "static/media/image_60.f4b187ea.png";